import dayjs, { Dayjs } from 'dayjs'

import { getServerNow } from '@/components/entities/common/model/server-time'
import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'

type DateTimeInput = Date | string | number

const toZonedDate = (date: string) => dayjs(date).tz(DEFAULT_TIMEZONE)

export const toMskDayString = (dateTime: DateTimeInput) =>
  dayjs(dateTime).tz(DEFAULT_TIMEZONE).format('YYYY-MM-DD')

export const toMskDay = (value: DateTimeInput) =>
  dayjs.utc(value).tz(DEFAULT_TIMEZONE)

export const getMskNow = () => dayjs(getServerNow()).tz(DEFAULT_TIMEZONE)

export const formatFeedDate = (
  date?: string | null,
  format = 'DD MMMM YYYY'
) => {
  if (!date) {
    return ''
  }

  return date === dayjs().format('YYYY-MM-DD')
    ? 'Сегодня'
    : dayjs(date).format(format)
}

export const toMskCalendarDate = (dateTime: DateTimeInput) =>
  dayjs(toMskDayString(dateTime)).toDate()

const isLocalMidnight = (date: Date) =>
  date.getHours() === 0 &&
  date.getMinutes() === 0 &&
  date.getSeconds() === 0 &&
  date.getMilliseconds() === 0

export const toMskCalendarDay = (date?: Date) =>
  date && isLocalMidnight(date)
    ? dayjs.tz(dayjs(date).format('YYYY-MM-DD'), DEFAULT_TIMEZONE)
    : dayjs(date).tz(DEFAULT_TIMEZONE)

export const isDayInInterval = (
  date: Dayjs,
  startDate: Dayjs,
  endDate: Dayjs
) => {
  return date.isBetween(startDate, endDate, 'day', '[]')
}

export const formatTime = (
  timeStr: string,
  isTimeOnly: boolean = false,
  timeZone?: string
) => {
  if (isTimeOnly) {
    const today = new Date().toISOString().split('T')[0]
    return dayjs(`${today} ${timeStr}`).format('H:mm')
  }

  const time = timeZone ? dayjs.utc(timeStr).tz(timeZone) : dayjs(timeStr)

  return time.format('H:mm')
}

const getDateFormat = (date: string) => {
  const zonedDate = toZonedDate(date)
  const currentYear = dayjs().tz(DEFAULT_TIMEZONE).year()

  if (zonedDate.year() === currentYear) {
    return 'D MMMM'
  }
  return 'D MMMM YYYY'
}

export const getFormattedDate = (date: string) => {
  const zonedDate = toZonedDate(date)

  return zonedDate.format(getDateFormat(date))
}

export const getFormattedDateTime = (date: string) => {
  const zonedDate = toZonedDate(date)

  return zonedDate.format(`${getDateFormat(date)}, HH:mm`)
}
